'use strict';

angular.module('app.subscriptionAndBilling', [])
	.controller('subscriptionAndBillingCtrl', ['$scope', '$modal', '$modalInstance', 'subscriptionAndBillingService', 'TRACK_EVENTS',
		function ($scope, $modal, $modalInstance, subscriptionAndBillingService, TRACK_EVENTS){
		    var enableWatch = false;
		    $scope.packageID = null;
		    $scope.packageName = null;
		    $scope.packageMaxMention = null;
		    $scope.packageMaxProject = null;
		    $scope.packageMaxArea = null;
		    $scope.packageMaxCustomer = null;
		    $scope.packagePricePerMonth = null;

		    $scope.today = function() {
		        $scope.dt_invoiceDate = new Date();
		        $scope.dt_dueDate = new Date();
		    };
		    $scope.today();

		    $scope.clear = function () {
		        $scope.dt_invoiceDate = null;
		        $scope.dt_dueDate - null;
		    };

		    // Disable weekend selection
		    $scope.disabled = function(date, mode) {
		        return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
		    };

		    $scope.toggleMin = function() {
		        $scope.minDate = $scope.minDate ? null : new Date();
		    };
		    $scope.toggleMin();

		    $scope.openInvoiceDate = function($event,option) {
		        $event.preventDefault();
		        $event.stopPropagation();

		        $scope.openedInvoiceDate = true;
		    };
		    $scope.openDueDate = function($event,option) {
		        $event.preventDefault();
		        $event.stopPropagation();

		        $scope.openedDueDate = true;
		    };

		    $scope.dateOptions = {
		        formatYear: 'yy',
		        startingDay: 1
		    };

		    $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
		    $scope.format = $scope.formats[2];

		    $scope.saveInvoice = function(){
		        $scope.closeModal = function() {
		            $modalInstance.close();
		        }
		    }

		    $scope.cancelInvoice = function() {
		        if($scope.companySubscription != null && $scope.companySubscription != undefined){
		            enableWatch = false;
		            $scope.getCompanySubscription();
		        }
		        else{
		            $scope.currentSubscription.forEach(function (val) {
		                val.ticked = false;
		            })

		            $scope.monthly.forEach(function (val) {
		                val.ticked = false;
		            })
		            $scope.mentions = null;
		            $scope.projects = null;
		            $scope.area = null;
		            $scope.pricePerMonth = null;
		            $scope.maxCustomers = null;
		            $scope.vatSubscription = null;
		            $scope.totalPricePerMonth = null;
		        }     
		    }

		    $scope.setPayment = function(){
		        var modalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/subscriptionAndBilling/setPaidSubscription/setPaidSubscription.html?app_v=deployDate',
		            controller: 'setPaidSubscriptionCtrl'
		        });
		        $scope.modalInstance = modalInstance;
		    }

		    $scope.preloadDataModal = function(){
		    	subscriptionAndBillingService.getAllInvoicePeriod(false)
		    		.then(function(response) {
		    			$scope.monthly = response.data;
		    			subscriptionAndBillingService.getPackageForFilter(false)
				    		.then(function(response) {
				    			$scope.currentSubscription = response.data;
				    			$scope.getAccountSubscription();
				    		}, function(response) {
				    			var errorModalInstance = $modal.open({
				                    scope: $scope,
				                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
				                    windowClass: 'modal-dialog-mention-error'
				                });
				                $scope.errorModalInstance = errorModalInstance;
				                $scope.errorMessage = response.message;
				    		})
		    		}, function(response) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		    		})	                    
		    }

		    $scope.getAccountSubscription = function(){
		    	subscriptionAndBillingService.getAccountSubscription($scope.company_id, false)
		    		.then(function(responseAccountSubscription) {
		    			if(responseAccountSubscription.data != null) {
		                    $scope.companySubscription = responseAccountSubscription.data;
		                    $scope.renderAllFields(responseAccountSubscription.data);
		                    $scope.renderInvoicePeriod(responseAccountSubscription.data);
		                    $scope.renderPackage(responseAccountSubscription.data);
		                } else {
		                    enableWatch = true;
		                }
		    		}, function(response) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		    		})
		    }

		    $scope.renderAllFields = function(data){
		        if(data != null){
		            $scope.renderInvoicePeriod(data);
		            $scope.renderPackage(data);
		            $scope.packageID = data.package_id;
		            $scope.packageName = data.package_name;
		            $scope.packageMaxMention = data.package_max_mention;
		            $scope.packageMaxProject = data.package_max_project;
		            $scope.packageMaxArea = data.package_max_area;
		            $scope.packageMaxCustomer = data.package_max_customer;
		            $scope.packagePricePerMonth = data.package_price_per_month;
		            $scope.packageVAT = data.vat;
		            $scope.packageTotalPricePerMonth = data.total;

		            $scope.mentions = $scope.packageMaxMention;
		            $scope.pricePerMonth = $scope.packagePricePerMonth;
		            $scope.projects = $scope.packageMaxProject;
		            $scope.maxCustomers = $scope.packageMaxCustomer;
		            $scope.area = $scope.packageMaxArea;
		            $scope.vatSubscription = $scope.packageVAT;    

		        }
		    }

		    $scope.renderInvoicePeriod = function(data){
		        $scope.monthly.forEach(function(value){
		            value.ticked = false;
		        })

		        for(var i = 0; i < $scope.monthly.length; i++){
		            if ($scope.monthly[i].id == data.invoice_period) {
		                $scope.monthly[i].ticked = true;
		                $scope.selectedInvoicePeriod = $scope.monthly[i];
		                break;
		            }   
		        }
		    }

		    $scope.renderPackage = function(data){     
		        $scope.currentSubscription.forEach(function(value){
		            value.ticked = false;
		        })

		        for(var i = 0; i < $scope.currentSubscription.length; i++){
		            if ($scope.currentSubscription[i].id == data.package_id) {
		                $scope.currentSubscription[i].ticked = true;
		                $scope.selectedSubscription = $scope.currentSubscription[i];
		                break;
		            }             
		        }
		    }

		    $scope.preloadDataModal();

		    $scope.$watch('selectedSubscription', function(newValue, oldValue){

		        if(!enableWatch && newValue !== oldValue && newValue !== undefined && newValue.length != undefined){
		            if($scope.companySubscription != null && $scope.companySubscription !== undefined){
		                $scope.renderAllFields($scope.companySubscription);
		                enableWatch = true;
		            }                                
		        }        
		        else if(enableWatch && newValue !== oldValue && newValue !== undefined && newValue.length != undefined)
		        {
		            $scope.selectedValues = [];
		            $scope.newPackage = newValue;
		            angular.forEach($scope.newPackage, function(val){
		                $scope.selectedValues.push( val.id);
		                $scope.selectedValues.push( val.name);
		                $scope.selectedValues.push( val.max_mention);
		                $scope.selectedValues.push( val.max_project);
		                $scope.selectedValues.push( val.max_area);
		                $scope.selectedValues.push( val.max_customer);
		                $scope.selectedValues.push( val.price_per_month);
		                $scope.selectedValues.push( null );
		            });
		            $scope.packageID = $scope.selectedValues[0];
		            $scope.packageName = $scope.selectedValues[1];
		            $scope.packageMaxMention = $scope.selectedValues[2];
		            $scope.packageMaxProject = $scope.selectedValues[3];
		            $scope.packageMaxArea = $scope.selectedValues[4];
		            $scope.packageMaxCustomer = $scope.selectedValues[5];
		            $scope.packagePricePerMonth = $scope.selectedValues[6];
		            $scope.packageVAT = $scope.selectedValues[7];
		            $scope.packageTotalPricePerMonth = $scope.selectedValues[6] * (1 + ($scope.packageVAT / 100));

		            $scope.mentions = $scope.packageMaxMention;
		            $scope.pricePerMonth = $scope.packagePricePerMonth;
		            $scope.projects = $scope.packageMaxProject;
		            $scope.maxCustomers = $scope.packageMaxCustomer;
		            $scope.area = $scope.packageMaxArea;
		            $scope.vatSubscription = $scope.packageVAT;

		        }
		       
		        
		    });

		    $scope.$watch('vatSubscription', function(newValue, oldValue){
		        if(newValue !== oldValue && newValue !== undefined)
		        {
		            $scope.selectedTotal = [];
		            $scope.newVATValue = newValue;

		            $scope.packageTotal = $scope.pricePerMonth * (1 + ($scope.newVATValue / 100));  
		            $scope.selectedTotal.push($scope.packageTotal);
		            $scope.packageTotalPricePerMonth = $scope.selectedTotal[0];
		        }
		    });

		    $scope.$watch('pricePerMonth', function(newValue, oldValue){
		        if(enableWatch && newValue !== oldValue && newValue !== undefined){

		            $scope.selectedTotal = [];
		            $scope.newPricePerMonth = newValue;
		            $scope.packageTotal = $scope.newPricePerMonth * (1 + ($scope.vatSubscription / 100));  
		            $scope.selectedTotal.push($scope.packageTotal);
		            $scope.packageTotalPricePerMonth = $scope.selectedTotal[0];
		        }
		    });

		    $scope.$watch('selectedInvoicePeriod', function(newValue, oldVaule){
		        $scope.selectedPeriod = [];
		        if(newValue !== oldVaule && newValue !== undefined)
		        {
		            $scope.selectInvoicePeriod = newValue;
		        }
		        angular.forEach($scope.selectInvoicePeriod, function(val){
		            $scope.selectedPeriod.push( val.id);
		        });
		        $scope.InvoicePeriod = $scope.selectedPeriod[0];
		    });

		    $scope.$watch('projects', function(newValue, oldVaule){
		        if(newValue !== oldVaule && newValue !== undefined)
		        {
		            $scope.packageMaxProject = newValue;
		        }
		    });
		    $scope.$watch('maxCustomers', function(newValue, oldVaule){
		        if(newValue !== oldVaule && newValue !== undefined)
		        {
		            $scope.packageMaxCustomer = newValue;
		        }
		    });
		    $scope.$watch('area', function(newValue, oldVaule){
		        if(newValue !== oldVaule && newValue !== undefined)
		        {
		            $scope.packageMaxArea = newValue;
		        }
		    });

		    $scope.saveNewSubscription = function(){
		        var params = {
		            company_id: $scope.company_id,
		            package_id: $scope.packageID,
		            package_name: $scope.packageName,
		            package_max_mention: $scope.mentions,
		            package_max_project: $scope.projects,
		            package_max_area: $scope.area,
		            package_max_customer: $scope.maxCustomers,
		            package_price_per_month: $scope.pricePerMonth,
		            total: $scope.packageTotalPricePerMonth,
		            vat: $scope.vatSubscription,
		            invoice_period: $scope.InvoicePeriod  
		        }

		        subscriptionAndBillingService.saveNewSubscription(params, true)
		        	.then(function(responseSaveNewSubscription) {
		        		// Mixpanel tracking upgrade subscription
		        		analytics.track(
		        		    TRACK_EVENTS.UPGRADE_SUBSCRIPTION.EVT_NAME,
		        		    {
		        		        "action": "Update",
		        		        "item": TRACK_EVENTS.UPGRADE_SUBSCRIPTION.ITEM_NAME,
		        		        "target_type": TRACK_EVENTS.UPGRADE_SUBSCRIPTION.ITEM_NAME,
		        		        "target_name": params.package_name,
		        		        "target_id": responseSaveNewSubscription.data.id,
		        		        "target_company_name": $scope.company_name,
		        		        "target_company_id": params.company_id,
		        		        "params": params
		        		    }
		        		);
		        		var newSubscriptionId = {
		                    id: responseSaveNewSubscription.data.id
		                };
			            $scope.invoiceAmount = $scope.packagePricePerMonth;
			            $scope.invoiceVAT = $scope.vatSubscription;
			            $scope.invoiceTotal = $scope.packageTotalPricePerMonth;
		        	}, function(responseSaveNewSubscription) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseSaveNewSubscription.message;
		        	})
		    }
}])